import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "backdrop"]

  disconnect() {
    // 페이지 이동 시 스크롤 잠금 해제
    document.body.style.overflow = ""
  }

  toggle() {
    this._isOpen() ? this.close() : this.open()
  }

  open() {
    document.body.style.overflow = "hidden"
    this.backdropTarget.style.display = "block"
    // 두 번의 rAF로 CSS transition이 확실히 발동하도록
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.backdropTarget.classList.add("is-open")
        this.drawerTarget.classList.add("is-open")
      })
    })
    this._bindEsc()
  }

  close() {
    this.backdropTarget.classList.remove("is-open")
    this.drawerTarget.classList.remove("is-open")
    this.drawerTarget.addEventListener("transitionend", () => {
      this.backdropTarget.style.display = "none"
      document.body.style.overflow = ""
    }, { once: true })
    this._unbindEsc()
  }

  _isOpen() {
    return this.drawerTarget.classList.contains("is-open")
  }

  _bindEsc() {
    this._onEsc = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this._onEsc)
  }

  _unbindEsc() {
    if (this._onEsc) {
      document.removeEventListener("keydown", this._onEsc)
      this._onEsc = null
    }
  }
}
